import {Toast } from "vant";
import "vant/lib/index.css";
import router from "@/router";
export function toast(message, duration = 5000,path) {
  Toast({
    message,
    duration,
    onClose(){
      // 跳转
      if(path)
        router.push({ path: path});
    }
  });
}


